export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
import dayjs from 'dayjs';
export function useFormatDate() {
    function formatDate(date, format = 'YYYY/MM/DD hh:ss') {
        if (!date)
            return '';
        return dayjs(date).format(format);
    }
    function formatDateToString(date) {
        if (!date)
            return '';
        return dayjs(date).format('MMM DD YYYY');
    }
    return {
        formatDate,
        formatDateToString,
    };
}
export const copyToClipboard = (str) => {
    navigator.clipboard.writeText(str).then(function () { }, function (err) {
        console.error('Could not copy text: ', err);
    });
};
export const truncate = (fullStr, strLen = 12, separator) => {
    if (fullStr.length <= strLen)
        return fullStr;
    separator = separator || '...';
    const sepLen = separator.length, charsToShow = strLen - sepLen, frontChars = Math.ceil(charsToShow / 2), backChars = Math.floor(charsToShow / 2);
    return (fullStr.substr(0, frontChars) +
        separator +
        fullStr.substr(fullStr.length - backChars));
};
export const randomId = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
export function formatDate(isoString) {
    // Create a new Date object from the ISO 8601 string
    const date = new Date(isoString);
    // Define an array of month names
    const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    // Extract the day, month, and year from the Date object
    const day = date.getUTCDate();
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    // Format the date in the desired format
    return `${month} ${day}, ${year}`;
}
export function formatBits(bits) {
    if (bits === 0)
        return '0 bytes';
    const sizes = ['bytes', 'KB', 'MB', 'GB'];
    const k = 1024;
    const i = Math.floor(Math.log(bits) / Math.log(k));
    // Ensure we don't exceed the available sizes array
    const readableValue = parseFloat((bits / Math.pow(k, i)).toFixed(2));
    const unit = sizes[i] || 'bytes';
    return `${readableValue} ${unit}`;
}
